import { useSelector } from 'react-redux';
import { myAccountSelector } from 'state/selectors/account';

const useIsFilterSetOwner = filterSet => {
  const account = useSelector(myAccountSelector);
  const accountId = account?.id;
  const filterSetAccountId = filterSet?.account_id;

  return accountId === filterSetAccountId;
};

export default useIsFilterSetOwner;
